import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Competency, CompetencyArea } from '../../types/GrowthWheel'

interface GrowthWheelPaginationProps {
    currentAreaIndex: number
    competencies: Competency[]
    userCompetencyAreasList: CompetencyArea[]
    handleClickPreviousArea: (index: number) => void
    handleClickNextArea: (index: number) => void
}

const GrowthWheelPagination = ({ currentAreaIndex, userCompetencyAreasList, handleClickPreviousArea, handleClickNextArea, competencies }: GrowthWheelPaginationProps) => {
    const previousArea = userCompetencyAreasList[currentAreaIndex - 1]
    const nextArea = userCompetencyAreasList[currentAreaIndex + 1]
    return (
        <div className="card shadow-sm gw-competency-area-footer">
            <div className="gw-competency-area-footer-content">
                <button style={{ padding: '18px 18px 18px 22px' }} className="gw-competency-area-footer-button" type="button" disabled={currentAreaIndex === 0} onClick={() => handleClickPreviousArea(currentAreaIndex - 1)}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    {previousArea?.name ?? "Previous Area"}
                </button>
                <div className="gw-competency-area-footer-dots">
                    {userCompetencyAreasList.map((area, index) => (
                        <span className={`gw-competency-area-footer-dot ${index === currentAreaIndex ? 'gw-competency-area-footer-dot--active' : ''}`} key={area.id} />
                    ))}
                </div>
                <button style={{ padding: '18px 22px 18px 18px' }} className="gw-competency-area-footer-button" type="button" disabled={currentAreaIndex === userCompetencyAreasList.length - 1} onClick={() => handleClickNextArea(currentAreaIndex + 1)}>
                    {nextArea?.name ?? "Next Area"}
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    )
}

export default GrowthWheelPagination